module.exports = __webpack_public_path__ + "img/Button-kosik-2021-06.a9fa9499.png";